
__webpack_require__.svgSprite = function(id) {
    return "/static/svg/sprite.d0a09f02.svg#" + id;
};
          